import { useQuery } from "@tanstack/react-query";
import { getQuotaUsageQueryKey } from "../queryKeys";
import api from "../../../services/api";
import { IUsageResponse } from "../@types/quotausage";
import { isAnyUsageQuotaNearLimit } from "../utils";

const REFETCH_INTERVAL = 5 * 60 * 1000;

const useQuotaUsage = (): {
  enabled: boolean;
  usage: IUsageResponse;
  someExceeded: boolean;
  someCloseToLimit: boolean;
} => {
  const { data } = useQuery({
    queryKey: getQuotaUsageQueryKey,
    queryFn: () => api.getTiCloudUsage(),
    refetchInterval: REFETCH_INTERVAL,
    refetchOnMount: false,
    refetchOnWindowFocus: true
  });

  const {
    enabled,
    usage = {},
    some_exceeded: someExceeded = false
  } = data?.data || {};

  const someCloseToLimit = isAnyUsageQuotaNearLimit(usage);

  return { enabled, usage, someExceeded, someCloseToLimit };
};

export default useQuotaUsage;
